import { Trophy, Calendar, Users, Briefcase } from 'lucide-react';
import { useEffect, useState } from 'react';
import './Stats.css';

const Stats = () => {
  const [counts, setCounts] = useState({
    hackathons: 0,
    years: 0,
    graduates: 0,
    students: 0
  });

  const statsData = [
    {
      value: counts.hackathons,
      label: "Проведено хакатонов",
      icon: <Trophy className="stat-icon" />,
      color: "#4f46e5"
    },
    {
      value: counts.years,
      label: "Года опыта",
      icon: <Calendar className="stat-icon" />,
      color: "#10b981"
    },
    {
      value: counts.graduates,
      label: "Выпускника проекта",
      icon: <Users className="stat-icon" />,
      color: "#f59e0b",
    },
    {
      value: counts.students,
      label: "Выпускника ITSchool",
      icon: <Briefcase className="stat-icon" />,
      color: "#ec4899",
    }
  ];

  useEffect(() => {
    const targetValues = {
      hackathons: 3,
      years: 3,
      graduates: 23,
      students: 28
    };

    const duration = 2000; 
    const interval = 50; 
    const steps = duration / interval;
    
    const counters = {};
    const increments = {};

    for (const key in targetValues) {
      increments[key] = targetValues[key] / steps;
      counters[key] = 0;
    }

    const timer = setInterval(() => {
      let completed = true;
      const newCounts = {};

      for (const key in targetValues) {
        counters[key] += increments[key];
        newCounts[key] = Math.floor(counters[key]);
        
        if (counters[key] < targetValues[key]) {
          completed = false;
        }
      }

      setCounts(newCounts);

      if (completed) {
        clearInterval(timer);
        setCounts(targetValues);
      }
    }, interval);

    return () => clearInterval(timer);
  }, []);

  return (
    <section className="stats-section">
      <div className="stats-grid">
        {statsData.map((stat, index) => {
          const content = (
            <div className="stat-card" key={index}>
              <div 
                className="stat-icon-container"
                style={{ backgroundColor: `${stat.color}20` }}
              >
                {stat.icon}
              </div>
              <div className="stat-content">
                <h3 className="stats-value">{stat.value}+</h3>
                <p className="stat-label">{stat.label}</p>
              </div>
            </div>
          );

          return content;
        })}
      </div>
    </section>
  );
};

export default Stats;